import { Injectable, Inject, RendererFactory2, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Product } from '../product/product-models';
import * as _ from 'lodash';
import { ManufacturerPrice } from '../manufacturer/manufacturer-models';
import * as momentLib from 'moment-timezone';
import { html2text, getObjectValue } from '@muchencute/mrrs-common';
import { Article } from '../article/article-models';
// å¨ Lib ç¼è¯æ¶éè¦æ­¤ç§åæ³ï¼ä¸ç¶ä¼æ¥é Cannot call a namespace ('moment')
// åè: https://stackoverflow.com/questions/39519823/using-rollup-for-angular-2s-aot-compiler-and-importing-moment-js/39818508
const moment = (momentLib as any).default ? (momentLib as any).default : momentLib;

@Injectable({
  providedIn: 'root',
})
export class SeoJsonLdService {

  constructor(private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document) { }

  attachArticle(item: Article, itemURL: string, publisherName: string, publisherLogo: string) {

    const json = {
      '@context': 'https://schema.org/',
      '@type': 'Article',
      'dateModified': moment(item.modificationdate, 'x').startOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
      'datePublished': moment(item.creationdate, 'x').startOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
      'headline': _.truncate(item.title, {
        length: 110,
        separator: ' '
      }),
      'image': [item.props.cover || ''],
      'publisher': {
        '@type': 'Organization',
        'name': publisherName,
        'logo': {
          '@type': 'ImageObject',
          'url': publisherLogo
        }
      },
      'author': {
        '@type': 'Person',
        'name': item.props.author
      },
      'mainEntityOfPage': {
        '@type': 'WebPage',
        '@id': itemURL
      },
      'description': _.truncate(html2text(item.props.content), {
        length: 320,
        separator: ' '
      })
    };

    this.attach(json);
  }

  attachProduct(item: Product, itemURL: string, sellerName: string, aggregateRating?: any, review?: any) {

    const price = _.first(item.prices) as ManufacturerPrice;

    const json = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      'name': item.name,
      'image': [item.props.cover],
      'description': html2text(item.props.section_Description, false),
      'sku': `REPORT-${item.code}`,
      'mpn': item.code,
      'brand': {
        '@type': 'Thing',
        'name': item.manufacturername
      },
      'aggregateRating': {
        '@type': 'AggregateRating',
        'ratingValue': aggregateRating ? aggregateRating.ratingValue : 5 || 5,
        'reviewCount': aggregateRating ? aggregateRating.reviewCount : 1 || 1
      },
      'review': {
        '@type': 'Review',
        'reviewRating': {
          '@type': 'Rating',
          'ratingValue': getObjectValue(review, 'reviewRating.ratingValue', 5),
          'bestRating': getObjectValue(review, 'reviewRating.bestRating', 5),
        },
        'author': {
          '@type': 'Person',
          'name': item.props.author
        }
      },
      'offers': {
        '@type': 'Offer',
        'url': itemURL,
        'priceCurrency': 'USD',
        'price': price.pricevalue,
        'priceValidUntil': moment().startOf('day').add(1, 'year').format('Y-M-D'),
        'itemCondition': 'https://schema.org/UsedCondition',
        'availability': 'http://schema.org/InStock',
        'seller': {
          '@type': 'Organization',
          'name': sellerName
        }
      }
    };

    this.attach(json);
  }

  private attach(json: any) {

    const renderer = this.rendererFactory.createRenderer(this.document, {
      id: '-1',
      encapsulation: ViewEncapsulation.None,
      styles: [],
      data: {}
    });

    const s = renderer.createElement('script');
    s.type = 'application/ld+json';
    s.text = `${JSON.stringify(json)}`;

    const head = this.document.head;
    const elements = head.getElementsByTagName('script');
    const indexes = [];
    for (let i = 0; i < elements.length; i++) {
      if (elements.item(i).getAttribute('type') === 'application/ld+json') {
        indexes.push(i);
      }
    }
    indexes.forEach(i => head.removeChild(elements.item(i)));

    renderer.appendChild(head, s);
  }
}
